// removed by extract-text-webpack-plugin
module.exports = {"main":"icon-layout-main--3xLKN","alignMiddle":"icon-layout-alignMiddle--1ExR0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IconLayout/icon-layout.scss
// module id = Z8ef
// module chunks = 4